var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAgRegisterMobile(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 375,
    height: 842,
    viewBox: "0 0 375 842",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1004_1897)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 842,
    fill: "#F2703D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M904.857 435.526C879.338 460.164 794.901 541.377 759.97 568.541C726.053 594.908 691.451 615.115 655.804 620.61C557.723 634.367 513.764 623.755 437.007 579.882C344.965 527.272 218.866 455.188 12.0114 485.636C-208.05 518.027 -275.949 609.415 -366.219 694.847C-452.527 776.527 -491.819 792.434 -552.182 797.886C-639.747 805.8 -648.911 786.189 -707.559 808.052C-755.982 826.106 -801.993 905.463 -777.981 995.823C-756.042 1078.39 -654.931 1119.63 -522.235 1105.43C-324.454 1084.26 -213.081 998.551 -140.072 921.651C-78.5846 856.836 -42.1397 819.423 58.0425 804.677C158.225 789.931 205.722 814.988 283.272 859.339C375.319 911.944 493.682 956.614 700.545 926.195C762.535 917.083 820.469 896.477 856.719 880.173C910.442 856.019 925.128 846.597 955.41 824.505C1068.82 741.756 1152.01 624.624 1134.98 540.939C1107.57 406.326 979.921 363.064 904.857 435.526Z",
    fill: "#004468"
  }), /*#__PURE__*/React.createElement("rect", {
    y: 771,
    width: 375,
    height: 135,
    fill: "#004468"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1004_1897"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 375,
    height: 842,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAgRegisterMobile);
export default __webpack_public_path__ + "static/media/ag_register_mobile.cad0504de962f3518e174e8182aac95e.svg";
export { ForwardRef as ReactComponent };